import { EnrollmentStatus } from '@/pipeline/stateMachine';
import { Course, Campus, EnrollmentState } from './state';
import { MutationTree } from 'vuex';

const mutations: MutationTree<EnrollmentState> = {
  SET_ENROLLMENT_ID(state, enrollmentId: number) {
    state.enrollmentId = enrollmentId;
  },

  SET_DOCUMENTS_SENT(state, areDocumentsSent: boolean) {
    state.areDocumentsSent = areDocumentsSent;
  },

  SET_ENROLLMENT_STATUS(state, enrollmentStatus: EnrollmentStatus) {
    state.enrollmentStatus = enrollmentStatus;
  },

  SET_PARTNER_CODE(state, partnerCode: string) {
    state.partnerCode = partnerCode;
  },

  SET_COURSE(state, course: Course) {
    state.course = course;
  },

  SET_CAMPUS(state, campus: Campus) {
    state.campus = campus;
  },

  SET_HAS_ERROR_VOUCHER(state, hasErrorVoucher: boolean) {
    state.hasErrorVoucher = hasErrorVoucher;
  },

  SET_IS_COMPLEMENTARY_MODULE_ENABLE(state, isComplementaryModuleEnabled: boolean) {
    state.isComplementaryModuleEnabled = isComplementaryModuleEnabled;
  },

  SET_PERSONAL_ACADEMIC_RECORD(state, backofficeStudentAcademicRecord: string) {
    state.backofficeStudentAcademicRecord = backofficeStudentAcademicRecord;
  },
};

export default mutations;
